import React from 'react';
import { Col, Form } from 'react-bootstrap';

// DNI Input
const DNIInput = ({ c, i, values, handleInputChange }) => {
  return (
    <Col lg={6} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group>
        <Form.Label>{c.name + ' *'}</Form.Label>
        <Form.Control
          name="dni"
          type="text"
          required={true}
          onChange={handleInputChange}
          placeholder={c.placeholder}
          className="text-black"
          minLength={7}
          maxLength={9}
          isValid={values.dni?.length >= 7 && values.dni?.length <= 9}
          isInvalid={values.dni?.length > 9 || values.dni?.length < 7}
        />
        <Form.Control.Feedback type="invalid">
          Complete con un DNI correcto
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default DNIInput;
